import firebase from 'firebase'



  // Initialize Firebase
  var config = {
    apiKey: "AIzaSyC7i7-6R1zgafAPB91B1xfxDSnMmNVlkYk",
    authDomain: "mini-game-f14c5.firebaseapp.com",
    databaseURL: "https://mini-game-f14c5.firebaseio.com",
    projectId: "mini-game-f14c5",
    storageBucket: "",
    messagingSenderId: "102158851516"
  };
  firebase.initializeApp(config);